// Create a new file for context, e.g., ModalContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [pendingRedirect, setPendingRedirect] = useState(null);

  const showLoginModal = useCallback((redirectTo = null) => {
    // Guard against callsites that pass `showLoginModal` directly as an event
    // handler (e.g. `onClick={showLoginModal}`) — React would otherwise hand
    // us a SyntheticEvent here, which we'd later pass to `navigate()` and
    // crash with "Converting circular structure to JSON" via window refs.
    setPendingRedirect(typeof redirectTo === 'string' ? redirectTo : null);
    setLoginModalOpen(true);
  }, []);

  const hideLoginModal = useCallback(() => {
    setLoginModalOpen(false);
    setPendingRedirect(null);
  }, []);

  const consumePendingRedirect = useCallback(() => {
    let value = null;
    setPendingRedirect((current) => {
      value = current;
      return null;
    });
    return value;
  }, []);

  return (
    <ModalContext.Provider
      value={{
        isLoginModalOpen,
        showLoginModal,
        hideLoginModal,
        pendingRedirect,
        consumePendingRedirect,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
